import React, { memo, ReactNode } from 'react';
import Beamer from '~/view/containers/Beamer/Beamer';
import Zoho from '~/view/containers/Zoho/Zoho';
import './style.scss';

interface IProps {
  children?: ReactNode;
}

const Headers: React.FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <header className="header pr-4">
      <div className="d-flex flex-row full-width align-items-center gap-25">
        <div className="full-width">{props.children}</div>

        <div className="header__frames-wrapper">
          <Beamer />
          <Zoho />
        </div>
      </div>
    </header>
  );
};

export default memo(Headers);
